import { render, staticRenderFns } from "./HotMaxList.vue?vue&type=template&id=fd667444&scoped=true&"
import script from "./HotMaxList.vue?vue&type=script&lang=js&"
export * from "./HotMaxList.vue?vue&type=script&lang=js&"
import style0 from "./HotMaxList.vue?vue&type=style&index=0&id=fd667444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd667444",
  null
  
)

export default component.exports